<div class="div-arriere-plan-action" (click)="onDismiss(false)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div *ngIf="!isAssessors" class="flex gap-10">
        <img src="assets/suspend-icon.svg" class="icon-inline">
        <h3 class="bold header_title">Activation de la suspension du vote</h3>
      </div>

      <div class="dark-blue">
        <h2 class="text-md" style="margin: 13px 0px 5px 0px;">1. Message d'information pour les élécteurs</h2>
        <p class="text-md" style="margin: 5px 0px 5px 17px;">Rédigez le message qui sera affiché aux électeurs pendant
          la
          période de suspension.</p>
        <div style="display: flex; justify-content: space-between; flex-direction: column;">
          <textarea id="subject" class="name" maxlength="255" style="padding: 10px 20px;"
            (keyup)="onMessageInput($event)" resize="none"
            placeholder="{{'POLL-CREATION.FORM.EVENT-PLACEHOLDER' | translate}}"></textarea>
          <div [ngClass]="messageLength == 255 || messageLength == 0 ? 'character-counter-red' : 'character-counter'">
            {{messageLength}}/255</div>
        </div>
      </div>

      <div class="dark-blue" *ngIf="assessors.length > 0">
        <h2 class="text-md" style="margin: 10px 0px 5px 0px;">2. Saisir les clefs assesseurs</h2>
        <p class="text-md" style="margin: 5px 0px 5px 17px;">Entrez la clef à 6 chiffres de l’assesseur concerné. Les
          noms des
          trois assesseurs enregistrés sont affichés ci-dessous.</p>
      </div>

      <!-- Liste des assesseurs avec index -->
      <div *ngIf="assessors.length > 0" style="max-height: 185px; overflow-y: scroll;">
        <div *ngFor="let assessor of assessors; let i = index" class="assessor-item">
          <div class="flex align-items-center" style="margin-bottom: 10px;">
            <p class="text-md dark-blue" style="margin-right: 10px;">{{i + 1}}.</p>
            <img *ngIf="!isAssessorActive(assessor.email)" src="assets/hourglass-icon.svg" class="icon-inline">
            <img *ngIf="isAssessorActive(assessor.email)" src="assets/done-icon.svg" class="icon-inline">
            <div style="flex: 1; margin-right: 20px;" class="ml-10">
              <p class="no-margin dark-blue text-md">{{assessor.name}}</p>
              <p class="no-margin text-sm dark-blue opacity-60">{{assessor.email}}</p>
            </div>
            <div class="flex flex-column">
              <div style="display: flex; justify-content: flex-start;" class="gap-10">
                <p-inputOtp [length]="6" [integerOnly]="true" styleClass="otp-input-custom"
                  [disabled]="isAssessorActive(assessor.email)" [(ngModel)]="otpCodes[i]"
                  (ngModelChange)="onCodeInput($event, i)" />
              </div>
              <p class="no-margin text-xs red">{{suspendErrorMessage[i]}}</p>
            </div>
          </div>
        </div>
      </div>

      <div
        style="display: flex; justify-content: space-between; flex-direction: column; align-items: center; margin-top: 20px;">
        <button *ngIf="isSuspendReady" type="button" class="action-button orange-button" style="font-size: 16px;"
          (click)=onDismiss(true)>Suspendre</button>
        <button *ngIf="!isSuspendReady" type="button" class="action-button inactive-orange-button"
          style="font-size: 16px;" disabled>Suspendre</button>
        <p (click)=onDismiss(false) class="dark-blue pointer" style="margin-bottom: 0px;">Annuler</p>
      </div>
    </div>
  </div>
</div>